import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PromoBar } from "./components/PromoBar";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import FAQ from "./pages/FAQ";
import Schedule from "./pages/Schedule";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentReturn";
import GameDay from "./pages/GameDay";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Account from "./pages/Account";
import TeamStores from "./pages/TeamStores";
import SeniorNight from "./pages/SeniorNight";
import AuthCallback from "./pages/AuthCallback";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";

function StoreLayout({ children }) {
  return (
    <>
      <PromoBar />
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin") || pathname === "/gameday" || pathname.startsWith("/payment");
  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop/:category" element={<Shop />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/gameday" element={<GameDay />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/team-stores" element={<TeamStores />} />
      <Route path="/senior-night/:playerId" element={<SeniorNight />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
  return bare ? routes : <StoreLayout>{routes}</StoreLayout>;
}

function AppRouter() {
  const location = useLocation();
  // Detect the OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return <Shell />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <CustomerAuthProvider>
              <AppRouter />
              <Toaster theme="dark" position="top-center" richColors />
            </CustomerAuthProvider>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
